import styled from 'styled-components';

const FONT_SANS =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export type HintTone = 'ok' | 'warn';

export const HintRow = styled.div<{ $tone: HintTone }>`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 12px;
  font: 500 12px/1.4 ${FONT_SANS};
  background: ${({ $tone, theme: { colors = {} } }) => {
    const base =
      $tone === 'warn'
        ? colors.warning ?? '#E0A83C'
        : colors.tertiary ?? colors.primary ?? '#7FD1A0';
    return `color-mix(in oklch, ${base} 14%, transparent)`;
  }};
  color: ${({ $tone, theme: { colors = {} } }) =>
    $tone === 'warn'
      ? colors.warning ?? '#E0A83C'
      : colors.onSurfaceVariant ?? '#A1A3B8'};

  .material-symbols-rounded {
    font-size: 15px;
    line-height: 17px;
    flex: 0 0 auto;
  }
`;

export const HintText = styled.span`
  min-width: 0;
`;
